import {DeviceName, toHumanReadableDeviceName} from './DeviceName';

export function deviceRequirementsToString(deviceRequirements: DeviceRequirementRule[]): string {
    if (deviceRequirements.length === 0) {
        return 'any equipment';
    }

    return deviceRequirements
        .map((deviceRequirement) => {
            const devices = deviceRequirement.devices.map(toHumanReadableDeviceName).join(', ');
            if (deviceRequirement.devices.length === 1) {
                return devices;
            }

            if (deviceRequirement.requires_all) {
                return `all of ${devices}`;
            }

            return `one of ${devices}`;
        })
        .join(' and ');
}

export interface DeviceRequirementRule {
    requires_all: boolean;
    devices: DeviceName[];
}
